import { render } from "./Upload.vue?vue&type=template&id=2e768efb&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=2e768efb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e768efb"

export default script